/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import React from 'react';
import PropTypes from 'prop-types';
import { ChevronUp, ChevronLeft } from '@carbon/react/icons';

var NavCollapseButton = function NavCollapseButton(_ref) {
  var onClick = _ref.onClick,
    label = _ref.label,
    activeLabel = _ref.activeLabel,
    collapseButtonLocation = _ref.collapseButtonLocation,
    open = _ref.open;
  var CollapseIcon = collapseButtonLocation === 'top' ? ChevronUp : ChevronLeft;
  return /*#__PURE__*/React.createElement("button", {
    "aria-haspopup": "true",
    "aria-expanded": open,
    className: "cpc--side-nav__collapse-button ".concat(activeLabel ? 'cpc--side-nav__collapse-button--active' : ''),
    type: "button",
    onClick: onClick
  }, /*#__PURE__*/React.createElement("span", {
    className: "cds--assistive-text"
  }, label), activeLabel && /*#__PURE__*/React.createElement("span", {
    className: "cpc--side-nav__collapse-button-active-item"
  }, activeLabel), /*#__PURE__*/React.createElement(CollapseIcon, {
    className: "cpc--side-nav__collapse-button-icon"
  }));
};
NavCollapseButton.propTypes = {
  /**
   * The item that is currently active on the navigation
   */
  activeLabel: PropTypes.node,
  /**
   * The location of the collapseButton
   */
  collapseButtonLocation: PropTypes.string.isRequired,
  /**
   * A function to call when the collapse button is clicked.
   */
  onClick: PropTypes.func.isRequired,
  /**
   * The aria label to apply to the svg on the button.
   */
  label: PropTypes.string.isRequired,
  /**
   * Whether to menu is open or not
   */
  open: PropTypes.bool.isRequired
};
var NavCollapseButton$1 = NavCollapseButton;

export { NavCollapseButton$1 as default };
